import { Routes } from '@angular/router';
import { CanDeactivateGuard } from './core/guard/can-deactivate.guard';

export const routes: Routes = [
  {path: '', redirectTo: '/terminal', pathMatch: 'full'},

  {path: 'terminal', loadComponent: () => import('./terminal/terminal.component'), canDeactivate: [CanDeactivateGuard]},
  {path: 'ai', loadComponent: () => import('./ai/ai.component'), canDeactivate: [CanDeactivateGuard]},

  {path: 'terminal/chart/:market/:board/:symbol', loadComponent: () => import('./terminal/preset.component')},
  {path: 'terminal/chart/:market/:board/:symbol/:timeframe', loadComponent: () => import('./terminal/preset.component')},
  {path: 'terminal/key/:keyId', loadComponent: () => import('./terminal/preset.component')},
]
